<template>
    <div v-if="type === 'youtube'" v-bind="$attrs">
        <iframe v-if="!thumbnailOnly" class="w-full aspect-video rounded-lg lazy"
                :data-src="`https://www.youtube.com/embed/${this.clip}?fs=0&modestbranding=1`"
                frameborder="0"></iframe>

        <img v-else
             class="w-full aspect-video rounded-lg lazy"
             :src="`https://img.youtube.com/vi/${clip}/maxresdefault.jpg`">
    </div>
    <div v-if="type === 'vimeo'" v-bind="$attrs">
        <iframe class="w-full aspect-video rounded-lg lazy"
                :data-src="`https://player.vimeo.com/video/${this.clip}`"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen=""></iframe>
    </div>
</template>

<script>
import LazyLoad from "vanilla-lazyload";

export default {
    name: "AppVideo",
    components: { LazyLoad },
    props: {
        type: String,
        clip: String,
        thumbnailOnly: Boolean
    },
    mounted()
    {
        var lazyLoadInstance = new LazyLoad({elements_selector: `.lazy`});
    }
}
</script>

<style scoped>

</style>
